import { useState } from 'react';
import { updatePassword, signOut } from '../supabase';
import { MarcoAcceso, CampoClave } from './AccesoMarco';
import { CLAVE_MIN, validarClave, traducirErrorAuth } from '../utils/claveAuth';

// ═══════════════════════════════════════════════════════════════════════════════
// RECOVERY (Fase 3) — pantalla de "nueva contraseña".
// Se muestra cuando onAuthChange recibe el evento PASSWORD_RECOVERY (enlace del
// correo abierto en el dominio verde). Hay una sesión temporal activa, así que
// updateUser({ password }) funciona sin pedir la clave anterior.
// Al terminar limpia también el flag de clave temporal (clearMustChange por defecto).
// ═══════════════════════════════════════════════════════════════════════════════

export default function RecoveryScreen({ onDone }) {
  const [p1, setP1]   = useState('');
  const [p2, setP2]   = useState('');
  const [show, setShow] = useState(false);
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);
  const [ok, setOk]   = useState(false);

  const submit = async () => {
    setErr('');
    const falta = validarClave(p1);
    if (falta)            { setErr(falta); return; }
    if (p1 !== p2)        { setErr('Las contraseñas no coinciden.'); return; }
    setBusy(true);
    try {
      const { error } = await updatePassword(p1);   // limpia must_change_password
      if (error) { setErr(traducirErrorAuth(error, 'No se pudo actualizar la contraseña. El enlace pudo expirar; solicita uno nuevo.')); setBusy(false); return; }
      setOk(true);
    } catch {
      setErr('Error de conexión. Intenta de nuevo.');
    }
    setBusy(false);
  };

  const onKey = (e) => { if (e.key === 'Enter') submit(); };

  return (
    <MarcoAcceso>
      <h2 className="lg-h">Restablecer contraseña</h2>

      {ok ? (
        <>
          <div className="lg-msg ok">Contraseña actualizada. Ya puedes ingresar con tu nueva contraseña.</div>
          <button className="lg-btn" onClick={()=>{ onDone?.(); }}>Continuar</button>
        </>
      ) : (
        <>
          <p className="lg-sub">Define una nueva contraseña de al menos {CLAVE_MIN} caracteres, con letras y números.</p>

          <CampoClave id="rc-p1" label="Nueva contraseña" show={show} onToggle={()=>setShow(!show)}
            autoComplete="new-password" value={p1} onChange={e=>{setP1(e.target.value);setErr('');}}
            onKeyDown={onKey} autoFocus />
          <CampoClave id="rc-p2" label="Confirmar contraseña" show={show} conBoton={false}
            autoComplete="new-password" value={p2} onChange={e=>{setP2(e.target.value);setErr('');}}
            onKeyDown={onKey} placeholder="Repite la contraseña" />

          {err && <div className="lg-msg error">{err}</div>}

          <button className="lg-btn" onClick={submit} disabled={busy}>
            {busy ? 'Guardando…' : 'Guardar contraseña'}
          </button>

          <div className="lg-centro">
            <button className="lg-link" onClick={async()=>{ await signOut(); onDone?.(); }}>
              Cancelar
            </button>
          </div>
        </>
      )}
    </MarcoAcceso>
  );
}
